import App from "../../app";
import { AttemptId, ItemId, ProductId, QuizId } from "../../model/datasource";
import { ContentItem } from "../../model/datasource/item";
import { ReviewScore } from "../../model/datasource/score";
import { HeaderFrontend } from "../frontend";
import { HeaderView } from "../view";
import { ReviewTotalScoreChart, TestProgressChart } from "../../lib/chart";

export class ListHeaderView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends HeaderView<P, A, Z, I> {
	frontend: HeaderFrontend<I>;

	constructor(frontend?: HeaderFrontend<I>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void {
		// Do nothing.
	}

	displayProgress(chart: TestProgressChart, complete: number, total: number): void {
		throw new Error('Method not implemented.');
	}

	displayTotalScores(chart: ReviewTotalScoreChart, total: ReviewScore): void {
		throw new Error('Method not implemented.');
	}

	displayItem(content: ContentItem<I>): void {
		throw new Error('Method not implemented.');
	}

	displayTotalTime(time: number): void {
		throw new Error('Method not implemented.');
	}

	displayTimer(show: boolean): void {
		throw new Error('Method not implemented.');
	}

	displayNext(show: boolean): void {
		// Do nothing.
	}

	displayPrevious(show: boolean): void {
		// Do nothing.
	}

	displayFinish(show: boolean): void {
		// Do nothing.
	}

	displayFlag(flagged: boolean | null): void {
		this.frontend.displayFlag(flagged);
	}

	displayCountdown(show: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayCurrentTime(time: number): void {
		throw new Error("Method not implemented.");
	}

	displayCountdownTime(time: number): void {
		throw new Error("Method not implemented.");
	}

	displayRandomize(randomize: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayPosition(index: number, length: number): void {
		// Do nothing.
	}
}

